import type { DoneAccessoryBarProps } from "./DoneAccessoryBar";

const DoneAccessoryBar = (_props: DoneAccessoryBarProps) => null;

export default DoneAccessoryBar;
